var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 3.25C1.07272 3.25 0.625 3.69772 0.625 4.25C0.625 4.80228 1.07272 5.25 1.625 5.25H5.875V15.625C5.875 16.1773 6.32272 16.625 6.875 16.625C7.42729 16.625 7.875 16.1773 7.875 15.625V5.25H12.125C12.6773 5.25 13.125 4.80228 13.125 4.25C13.125 3.69772 12.6773 3.25 12.125 3.25H1.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0112 4.80877C16.8751 4.40043 16.4929 4.125 16.0625 4.125C15.6321 4.125 15.2499 4.40043 15.1138 4.80877L14.7251 5.97506L13.5588 6.36382C13.1504 6.49993 12.875 6.88207 12.875 7.3125C12.875 7.74293 13.1504 8.12507 13.5588 8.26118L14.7251 8.64994L15.1138 9.81623C15.2499 10.2246 15.6321 10.5 16.0625 10.5C16.4929 10.5 16.8751 10.2246 17.0112 9.81623L17.3999 8.64995L18.5662 8.26118C18.9746 8.12507 19.25 7.74293 19.25 7.3125C19.25 6.88207 18.9746 6.49993 18.5662 6.36382L17.3999 5.97506L17.0112 4.80877Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 11.125C12.9929 11.125 13.3751 11.4004 13.5112 11.8088L13.8999 12.9751L15.0662 13.3638C15.4746 13.4999 15.75 13.8821 15.75 14.3125C15.75 14.7429 15.4746 15.1251 15.0662 15.2612L13.8999 15.6499L13.5112 16.8162C13.3751 17.2246 12.9929 17.5 12.5625 17.5C12.1321 17.5 11.7499 17.2246 11.6138 16.8162L11.2251 15.6499L10.0588 15.2612C9.65043 15.1251 9.375 14.7429 9.375 14.3125C9.375 13.8821 9.65043 13.4999 10.0588 13.3638L11.2251 12.9751L11.6138 11.8088C11.7499 11.4004 12.1321 11.125 12.5625 11.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddText);
export default __webpack_public_path__ + "static/media/add-text.002e606b.svg";
export { ForwardRef as ReactComponent };